module.exports = __webpack_public_path__ + "media/images/background/8-70307062739ec9b50f0fce878d3f0d49.jpg";